var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action whatsapp-action",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v("עדיף לי בוואטסאפ")]),_vm._v(" "),_c('img',{staticClass:"whatsapp-icon",attrs:{"src":require('@/assets/icons/whatsapp-icon.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }